function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import classNamesMaker from "classnames";
import styles from "./Spinner.module.css";

// eslint-disable-next-line @typescript-eslint/no-var-requires
var _require = require("nanoid"),
  nanoid = _require.nanoid;
export var Spinner = function Spinner(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "" : _ref$id,
    _ref$minor = _ref.minor,
    minor = _ref$minor === void 0 ? false : _ref$minor,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$gradientStopClas = _ref.gradientStopClassName,
    gradientStopClassName = _ref$gradientStopClas === void 0 ? "" : _ref$gradientStopClas,
    _ref$ghost = _ref.ghost,
    ghost = _ref$ghost === void 0 ? false : _ref$ghost;
  var customClassNames = classNamesMaker(styles["jds-Spinner"], _defineProperty({}, styles["jds-Spinner--minor"], minor), _defineProperty({}, styles["jds-Spinner--ghost"], ghost), className);
  var spinnerId = id || "spinner-gradient-".concat(nanoid());
  return /*#__PURE__*/React.createElement("svg", {
    className: customClassNames,
    viewBox: "0 0 96 96",
    strokeDasharray: "263.467529296875",
    strokeDashoffset: "243.467529296875",
    strokeLinecap: "round",
    fill: "none",
    role: "presentation"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: spinnerId
  }, /*#__PURE__*/React.createElement("stop", {
    className: gradientStopClassName,
    offset: "30%",
    stopColor: "currentcolor"
  }), /*#__PURE__*/React.createElement("stop", {
    className: gradientStopClassName,
    offset: "100%",
    stopColor: "currentcolor",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "url(#".concat(spinnerId, ")"),
    cx: "48",
    cy: "48",
    r: "42"
  }));
};